<template>
  <embedded-crud-table
    :allow-create="false"
    :allow-delete="true"
    :allow-edit="false"
    :entity="entity"
    :entity-store="entityStore"
    :columns="columns"
    :generate-summary="generateSummary"
    :caption="caption"
    :disabled="disabled"
    :parent-id-filter-field="parentIdFilterField"
    :open-in-fullscreen="openInFullscreen"
    :required="required"
    :permission-code="permissionCode"
    :tabbed="tabbed"
    :definition="{}"
    :editor-is-popup="editorIsPopup"
    :on-create="() => {}"
    :on-edit="() => {}"
    :on-table-row-double-click="null"
    :show-edit="() => {}"
    :show-create="() => {}"
  />
</template>

<script>
import EmbeddedCrudTable from '@/components/crud/EmbeddedCrudTable';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';

export default {
  components: {
    EmbeddedCrudTable
  },
  mixins: [baseCrudMixin],
  props: {
    caption: String,
    parentIdFilterField: {
      type: String,
      required: true
    },
    permissionCode: String,
    disabled: {
      default: false,
      type: Boolean
    },
    columns: {
      default: () => [
        { field: 'shipToPostCode', label: 'common.postalCode', width: '120' },
        { field: 'shipToStreet', label: 'common.streetName' },
        { field: 'shipToStreetNumber', label: 'common.streetNumber', width: '120' },
        { field: 'shipToCity', label: 'common.city' },
        { field: 'shipToAddressee', label: 'common.addressee' },
        { field: 'shipToPhoneNr', label: 'common.phone' },
        { field: 'shipToEmail', label: 'common.email' },
        { field: 'orderNumber', label: 'orderLine.familyOrder' }
      ],
      type: Array
    },
    openInFullscreen: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    },
    tabbed: {
      default: true,
      type: Boolean
    },
    editorIsPopup: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    entity: 'Shipment',
    returnTo: 'Shipments'
  }),
  computed: {
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  methods: {
    generateSummary(row) {
      return `${row.shipToPostCode} ${row.shipToStreet} ${row.shipToStreetNumber} ${row.shipToCity}`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
